
import { alpha, styled } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon } from '@mui/material';
// config
import { ICON, NAVBAR } from 'config';

// ----------------------------------------------------------------------

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeSub' && prop !== 'subItem'
})(({ activeSub, subItem, theme }) => ({
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_ROOT_HEIGHT ,
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(1.5),
  color: 'white',
  fontSize: '18px !important',

  '&:hover': {
    color: theme.palette.primary.main,
    background: `${alpha(theme.palette.background.paper, 0.9)} !important`,
    borderLeft: `solid ${theme.palette.primary.main}`,
    borderLeftWidth: 3,
    borderRight: `solid ${theme.palette.primary.main}`,
    borderRightWidth: 3
  },


  // subItem
  ...(subItem && {
    borderBottom: `solid ${theme.palette.divider}`,
    borderBottomWidth: 1,
    background: 'white',
    fontSize: '16px !important',
    color: theme.palette.primary.main,
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.paper, 0.8)
    }
  }),
  // activeSub
  ...(activeSub && {
    borderLeft: `solid ${theme.palette.primary.main}`,
    borderLeftWidth: 8,
    fontWeight: 'bold',
    backgroundColor: alpha(theme.palette.background.paper, 0.8),

  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse'
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0
  })
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: ICON.NAVBAR_ITEM,
  height: ICON.NAVBAR_ITEM,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' }
});
